import WidgetTables from 'components/WidgetTables';
import {useEmblaCarousel} from 'embla-carousel/react';
import React, {FC, Ref, RefObject, useCallback, useEffect, useMemo, useState} from 'react';
import {createPortal} from 'react-dom';

import {CompetitionTablesTeam} from 'utils/types';

import './styles.scss';

const MatchcenterStandingsWidget: FC<{
  competitionName: string;
  groups: {name: string; teams: CompetitionTablesTeam[]}[];
  root: HTMLElement | null;
  isCarousel?: boolean;
}> = ({
  competitionName,
  groups,
  root,
  isCarousel = false,
}: {
  competitionName: string;
  groups: {name: string; teams: CompetitionTablesTeam[]}[];
  root: HTMLElement | null;
  isCarousel?: boolean;
}) => {
  const [emblaRef, embla] = useEmblaCarousel();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const scrollTo = useCallback((index: number) => embla && embla.scrollTo(index), [embla]);
  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
  }, [embla, setSelectedIndex]);
  useEffect(() => {
    if (!embla) return;
    onSelect();
    embla.on('select', onSelect);
  }, [embla, onSelect]);
  return (
    root &&
    createPortal(
      <section
        className={`MatchcenterStandingsWidget ${
          isCarousel ? 'MatchcenterStandingsWidget--carousel' : ''
        }`}
      >
        <h1 className="MatchcenterStandingsWidget__header">ΒΑΘΜΟΛΟΓΙΑ</h1>
        <h2 className="MatchcenterStandingsWidget__competition">{competitionName}</h2>
        {isCarousel ? (
          <>
            <div className="MatchcenterStandingsWidget__carousel" ref={emblaRef}>
              <div className="MatchcenterStandingsWidget__carousel-container">
                {groups.map(group => (
                  <WidgetTables
                    key={group.name}
                    label={groups.length > 1 ? group.name : ''}
                    competitionTables={group.teams}
                    narrow={isCarousel}
                  />
                ))}
              </div>
            </div>
            <div className="MatchcenterStandingsWidget__carousel-dots">
              {groups.map((group, index) => (
                <button
                  type="button"
                  className={`MatchcenterStandingsWidget__carousel-dot ${
                    selectedIndex === index
                      ? 'MatchcenterStandingsWidget__carousel-dot--active'
                      : ''
                  }`}
                  key={group.name}
                  onClick={() => scrollTo(index)}
                />
              ))}
            </div>
          </>
        ) : (
          <>
            {groups.map(group => (
              <WidgetTables
                key={group.name}
                label={groups.length > 1 ? group.name : ''}
                competitionTables={group.teams}
                narrow={isCarousel}
              />
            ))}
          </>
        )}
        <div className="MatchcenterStandingsWidget__footer">
          <a href="/vathmologies/" className="MatchcenterStandingsWidget__button">
            ΟΛΕΣ ΟΙ ΒΑΘΜΟΛΟΓΙΕΣ
          </a>
        </div>
      </section>,
      root
    )
  );
};

export default React.memo(MatchcenterStandingsWidget);
